module.exports = __webpack_public_path__ + "static/media/icon-header-review.6e33b9b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-review.svg
// module id = 1513
// module chunks = 193